import { ConfigFacadeService } from '@core/services/config/config-facade.service';
import { Title } from '@angular/platform-browser';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PartnerService {
	constructor(private appConfig: ConfigFacadeService, private titleService: Title) {}

	public init(): void {
		const partnerName = this.appConfig.config.partner.name;
		this.setTitle(partnerName);
	}

	private setTitle(partnerName: string): void {
		const title = `${partnerName} - Dashboard`;
		this.titleService.setTitle(title);
	}
}
